import middlewares from '@/middlewares/http-common';
import { handleResponse, handleError } from './';
import { IBingoScore } from '../../interface/bingoScore.js';

class BingoService {
  sendBingoInfo(bingoScore: IBingoScore) {
    return middlewares.httpJson
      .post('/bingo/data', bingoScore)
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response));
  }

  getScoreboard(): Promise<Array<IBingoScore>> {
    return middlewares.httpJson
      .get('/bingo/scoreboard')
      .then((resp) => handleResponse(resp))
      .catch((err) => handleError(err.response)) as Promise<Array<IBingoScore>>;
  }
}

export default new BingoService();
